/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
// const Cleave = require( 'cleave.js' );
import 'cleave.js/dist/cleave.min.js';
import 'cleave.js/dist/addons/cleave-phone.i18n.js';
// require( 'cleave.js/dist/addons/cleave-phone.{country}.js' );
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.js-init-bio' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( '.js-init-content' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      if ( $( '.ginput_container_phone input' ).length ) {
        const cleave = new Cleave( '.ginput_container_phone input', {
          phone: true,
          phoneRegionCode: 'us',
        } );
      }

      $( '.ginput_container_phone .select-wrapper select' ).change( function() {
        cleave.setPhoneRegionCode( this.value );
        cleave.setRawValue( '' );
      } );

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      $( document ).on( 'click', '.bookmark-button', function() {
        updateUserBookmarks( this );
      } );

      function updateUserBookmarks( button ) {
        let doingAjax = true;
        const data = {
          'user_id': $( button ).attr( 'data-user-id' ),
          'post_id': $( button ).attr( 'data-post-id' ),
          'post_type': $( button ).attr( 'data-post-type' ),
        };

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/updateUserBookmarks',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            if ( data.buttonStatus == 'add' ) {
              $( button ).addClass( 'bookmarked' );
            } else {
              $( button ).removeClass( 'bookmarked' );
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }

      $( '.print-certificate' ).on( 'click', function() {
        window.print();
      } );

      $( 'a[href*="add-to-cart"]' ).on( 'click', function( event ) {
        event.preventDefault();
        const link = $( this )[0];
        const urlParams = new URLSearchParams( new URL( link.href ).search );
        const productId = urlParams.get( 'add-to-cart' );

        if ( productId ) {
          let doingAjax = null;
          window.dataLayer = window.dataLayer || [];

          $.ajax( {
            type: 'GET',
            url: site_info.wpApiSettings.ll + 'cpt/getProductPriceById',
            data: {
              'product_id': productId,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              window.dataLayer.push( {
                event: 'add_to_cart',
                revenue: data.price,
                currency: 'USD',
                items: [{
                  item_id: productId,
                  price: data.price,
                  item_name: 'Product ' + productId, // Replace with actual product name if needed
                  quantity: 1,
                }],
              } );
              console.log( 'Add to Cart Event Triggered for Product ID:', productId );
              window.location.href = link.href;
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
